import type { ApiResponse } from '../../types'
import type { MeResponse } from '../../types/community'
import { client, unwrap, apiError, CotApiError } from './client'

/**
 * GET /api/v1/community/me — the shell's identity + counters payload.
 *
 * Throws a {@link CotApiError}. A 404 (`family_not_found`) means the caller's
 * tenant has no CotFamily yet — the SPA routes such users into the signup wizard.
 */
export async function getMe(): Promise<MeResponse> {
  try {
    const res = await client.get<ApiResponse<MeResponse>>('/me')
    return unwrap(res.data)
  } catch (err) {
    if (err instanceof CotApiError) throw err
    throw apiError(err)
  }
}
